import React from 'react';
import { Check } from 'lucide-react';
import { t } from '../i18n';
import './VocabularyDirectionMenuItems.css';

export function vocabularyDirectionLabel(direction, { questionLocale = 'ko-KR', learningLocale = 'en-US' } = {}) {
  const reverse = direction === 'a_to_q';
  const question = t(`noteComposer.locales.${questionLocale}`);
  const answer = t(`noteComposer.locales.${learningLocale}`);
  return t('vocabulary.directionValue', undefined, {
    direction: reverse ? 'A → Q' : 'Q → A',
    languages: reverse ? `${answer} → ${question}` : `${question} → ${answer}`,
  });
}

export default function VocabularyDirectionMenuItems({ direction = 'q_to_a', questionLocale, learningLocale, disabled, onChange }) {
  return <div className="vocabulary-direction-options" role="group" aria-label={t('vocabulary.direction')}>
    <span className="vocabulary-direction-options-heading" aria-hidden="true">{t('vocabulary.direction')}</span>
    {['q_to_a', 'a_to_q'].map(value => <button key={value} type="button" role="menuitemradio"
      aria-checked={direction === value} disabled={disabled} onClick={() => onChange(value)}>
      <Check size={16} aria-hidden="true" className={direction === value ? '' : 'is-unchecked'} />
      <span>{vocabularyDirectionLabel(value, { questionLocale, learningLocale })}</span>
    </button>)}
  </div>;
}
